import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import { Link } from "react-router-dom";
import Logo from "../atx-logo-front.png";
import Constants from "../Constants";
const Navigation = () => {
  return (
    <Navbar
      bg="primary"
      variant="dark"
      expand="lg"
      className="mr-auto"
      as="header"
      role="banner"
    >
      <Container fluid>
        <Link to="/" className="navbar-brand" aria-label="ATX Floods Home">
          <img className="img-responsive" src={Logo} alt="ATX Floods Logo" />
        </Link>
        <Navbar.Toggle
          aria-controls="navbarScroll"
          aria-label="Toggle navigation menu"
        />
        <Navbar.Collapse id="navbarScroll" className="ms-auto">
          <Nav role="navigation" aria-label="Main navigation">
            <Link to="/" className="nav-link">
              Home
            </Link>

            <Link to="/about" className="nav-link">
              About
            </Link>

            <NavDropdown
              title="Resources"
              id="basic-nav-dropdown"
              aria-label="External resources"
            >
              <NavDropdown.Item
                href="https://warncentraltexas.org/"
                target="_blank"
                rel="noopener noreferrer"
              >
                WarnCentralTexas{" "}
                <span className="visually-hidden">(opens in new window)</span>
              </NavDropdown.Item>
              <NavDropdown.Item
                href="https://hydromet.lcra.org/coa/"
                target="_blank"
                rel="noopener noreferrer"
              >
                LCRA Austin Hydromet{" "}
                <span className="visually-hidden">(opens in new window)</span>
              </NavDropdown.Item>
              <NavDropdown.Item
                href="https://maps.austintexas.gov/FloodPro/#/FloodProIntro/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Austin FloodPro{" "}
                <span className="visually-hidden">(opens in new window)</span>
              </NavDropdown.Item>
              <NavDropdown.Item
                href="https://txpub.usgs.gov/txwaterdashboard//"
                target="_blank"
                rel="noopener noreferrer"
              >
                USGS Texas Water Dashboard{" "}
                <span className="visually-hidden">(opens in new window)</span>
              </NavDropdown.Item>
              <NavDropdown.Item
                href="https://atxfloodsafety.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Flood Safety{" "}
                <span className="visually-hidden">(opens in new window)</span>
              </NavDropdown.Item>
              <NavDropdown.Item
                href={`${Constants.baseUrl("data-feed.xml")}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                Open Data Feed{" "}
                <span className="visually-hidden">(opens in new window)</span>
              </NavDropdown.Item>
              <NavDropdown.Item
                href="https://twitter.com/ATXfloods"
                target="_blank"
                rel="noopener noreferrer"
              >
                ATXFloods Twitter page{" "}
                <span className="visually-hidden">(opens in new window)</span>
              </NavDropdown.Item>
              <NavDropdown.Item
                href="https://www.weather.gov/ewx/"
                target="_blank"
                rel="noopener noreferrer"
              >
                National Weather Service Forecast{" "}
                <span className="visually-hidden">(opens in new window)</span>
              </NavDropdown.Item>
            </NavDropdown>

            <Link to="terms" className="nav-link">
              Terms
            </Link>
            <Link to="privacy" className="nav-link">
              Privacy
            </Link>
            <Link to="contact" className="nav-link">
              Contact
            </Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Navigation;
